import { render, staticRenderFns } from "./info_pcs2_20241204.vue?vue&type=template&id=0d8e0f7e&scoped=true&"
import script from "./info_pcs2_20241204.vue?vue&type=script&lang=js&"
export * from "./info_pcs2_20241204.vue?vue&type=script&lang=js&"
import style0 from "./info_pcs2_20241204.vue?vue&type=style&index=0&id=0d8e0f7e&scoped=true&lang=less&"
import style1 from "./info_pcs2_20241204.vue?vue&type=style&index=1&id=0d8e0f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8e0f7e",
  null
  
)

export default component.exports